<template>
  <v-row class="fill-height">
    <v-col cols="12" NewEditDeleteDialog class="fill-height">
      <v-dialog v-model="dialog" persistent fullscreen class="fill-height" style="overflow:xxxx!important;">
        <v-card :loading="loading" v-if="!deleting" class="fill-height pb-5" style="overflow: xxxx;">
          <v-card-title :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;">
            <div>{{ i18n[resourceSettings.resourceName]  + ' | ' }}<span class="font-weight-light">{{ newResource.id ? i18n.edit : i18n.add }}</span></div>
            <v-spacer></v-spacer>
            <v-btn 
              color="error"
              text 
              @click.native="closeDialog()" 
              :class="`${arabic?'arFont':'enFont'}`">
              {{i18n.cancelBtn}}
            </v-btn>
            <v-btn 
              color="success" 
              v-if="!newResource.id && steps == resourceSettings.steps.length"
              :disabled="!validate(newResource)"
              text @click.native="postResource(newResource)" 
              :class="`${arabic?'arFont':'enFont'}`"
            >{{i18n.submitBtn}}</v-btn>
            <v-btn 
                color="success" 
                v-if="newResource.id && steps == resourceSettings.steps.length"
                :disabled="!validate(newResource)"
                text @click.native="updateResource(newResource)" 
                :class="`${arabic?'arFont':'enFont'}`"
              >{{i18n.updateBtn}}</v-btn>
          </v-card-title>
          <v-card-text :style="`height:${getFrameHeight()}px;overflow:xxxx;`">
            <v-row  class="fill-height">
              <v-col cols="12" md="4" class="py-0 fill-height align-center">
                <v-row class="fill-height align-center">
                  <v-col cols="12" md="12" class="py-0">
                    <v-row class="pa-0">
                      <v-col cols="12" md="12" class="pa-0">
                        <v-stepper
                          v-model="steps"
                          class="elevation-0 pa-0"
                          vertical
                          dense
                        >
                          <span v-for="(st, i) in resourceSettings.steps" :key="'step'+i">
                            <v-stepper-step
                              :complete="steps > i"
                              :step="i+1"
                              class="pa-1"
                              editable
                            >
                              <small :class="`${arabic?'arFont':'enFont'}`">{{st.title}}</small>
                            </v-stepper-step>

                            <v-stepper-content :step="i+1">
                              <v-row class="pa-1">
                                <v-col cols="12" md="12" class="py-0" v-for="(field, k) in keys.filter(x=>x.step == i)" :key="'key-' + k">
                                  <Field
                                    :loading="loading"
                                    :field="field"
                                    @getUpload="getUpload"
                                    :newResource="newResource"
                                  />
                                </v-col>
                              </v-row>
                              <v-btn
                                color="primary"
                                @click="steps--"
                                v-if="steps > 0"
                                text
                                :class="`${arabic?'arFont':'enFont'}`"
                              >
                                Back
                              </v-btn>
                              <v-btn
                                color="primary"
                                @click="steps++"
                                v-if="steps < resourceSettings.steps.length"
                                text
                                :class="`${arabic?'arFont':'enFont'}`"
                              >
                                Next
                              </v-btn>
                              <v-btn 
                                color="error" v-if="steps == resourceSettings.steps.length" 
                                text 
                                @click.native="closeDialog()" 
                                :class="`${arabic?'arFont':'enFont'}`">
                                {{i18n.cancelBtn}}
                              </v-btn>
                              <v-btn 
                                color="success" 
                                v-if="!newResource.id && steps == resourceSettings.steps.length"
                                :disabled="!validate(newResource)"
                                text @click.native="postResource(newResource)" 
                                :class="`${arabic?'arFont':'enFont'}`"
                              >{{i18n.submitBtn}}</v-btn>
                              <v-btn 
                                  color="success" 
                                  v-if="newResource.id && steps == resourceSettings.steps.length"
                                  :disabled="!validate(newResource)"
                                  text @click.native="updateResource(newResource)" 
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >{{i18n.updateBtn}}</v-btn>
                            </v-stepper-content>
                          </span>
                        </v-stepper>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="8" class="pa-0 elevation-4 framecontainer" style="z-index:999;border-radius:15px;">
                <iframe id="ctaframe" src="https://testa.evotik.com" class="ctaframe" width="100%" height="100%" frameborder="0"></iframe>
                <div class="framelayer"></div>
              </v-col>
            </v-row>
          </v-card-text>
          
        </v-card>
        <v-card :loading="loading" v-if="deleting">
          <v-card-title :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;">
            <div>{{ i18n[resourceSettings.resourceName]  + ' | ' }}<span class="font-weight-light">{{i18n.delete}}</span></div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12" class="pa-5 error white--text">
                {{i18n.areYouSureOfDelete.replace('|item|', newResource.name )}}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click.native="closeDialog()" :class="`${arabic?'arFont':'enFont'}`">{{i18n.cancelBtn}}</v-btn>
            <v-btn 
                color="error" 
                v-if="newResource.id"
                text @click.native="deleteResource(newResource)" 
                :class="`${arabic?'arFont':'enFont'}`"
              >{{i18n.deleteBtn}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import Field from './Field'

export default {
  components:{Field},
  props:['dialog', 'deleting', 'resourceKeys', 'newResource', 'loading', 'resourceSettings'],
  data(){
    return {
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      datepicker:{},
      timepicker:{},
      menu:{},
      uploadProgress:null,
      uploadFiled:null,
      file:null,
      steps:1,
    }
  },
  methods: {
    getUpload(data) {
      this.$emit('getUpload', data )
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.required}`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.valid_email}`, 'error')
        }
      })
      return v
    },
    getFrameHeight() {
      return window.innerHeight - 50
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    closeDialog() {
      this.steps = 1
      this.$emit('closeDialog')
    },
    deleteResource(newResource) {
      this.$emit('deleteResource', newResource)
    },
    updateResource(newResource) {
      this.$emit('updateResource', newResource)
    },
    postResource(newResource) {
      this.$emit('postResource', newResource)
    },
    setLayerDs(){
      if(document.querySelector('.framelayer')) {
        console.log('frame there')
        document.querySelector('.framelayer').style.width = document.getElementById('ctaframe').offsetWidth + 'px'
        document.querySelector('.framelayer').style.height = document.getElementById('ctaframe').offsetHeight + 'px'
        document.querySelector('.framelayer').style.top = document.getElementById('ctaframe').offsetTop + 'px'
      } else {
        console.log('frame not there')
      }
    },
  },
  watch:{
    dialog(){
      this.setLayerDs()
    },
    newResource(){
      this.setLayerDs()
    },
  },
  computed:{
    
    keys(){
      console.log(this.newResource)
      return this.$store.state.resourceKeys[this.resourceSettings.resourceName].filter(x=> !x.types || (this.newResource.type && x.types.includes(this.newResource.type)))
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
  mounted(){
    this.setLayerDs()
  },
  afterMounted(){
    this.setLayerDs()
  }
}
</script>

<style>
.ctaframe {
  overflow:xxxx;
  height:100%;
  border-radius:15px;
}
.framelayer {
  position: absolute;
  border-radius: 15px;
  z-index: 9999999999999;
  background: #2196f38a;
}
</style>